import swal from 'sweetalert'

let alert = {
  showError(text = 'Error', time = 7000) {
    swal({
      text,
      icon: "error",
      timer: time
    })
  },
  showWarning(text = 'Warning', time = 7000) {
    swal({
      text,
      icon: "warning",
      timer: time,
    })
  },
  showSuccess(text = 'Success', time = 1500) {
    swal({
      text,
      icon: "success",
      timer: time,
      buttons: false
    })
  }
}

export default alert;